import { render, staticRenderFns } from "./create-unit-conversion.vue?vue&type=template&id=b1248134&scoped=true&"
import script from "./create-unit-conversion.vue?vue&type=script&lang=js&"
export * from "./create-unit-conversion.vue?vue&type=script&lang=js&"
import style0 from "./create-unit-conversion.vue?vue&type=style&index=0&id=b1248134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1248134",
  null
  
)

export default component.exports